// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import etask from '/util/etask.js';
import {Page} from '../../comp/page';
import {Text} from '../../comp/text';
import {Icon} from '../../comp/icon';
import {Panel} from '../../comp/panel';
import {Button} from '../../comp/button';
import * as api from '../../api.js';
import store from '../../store.js';
import {parse_qs, g_path} from '../../utils/path.js';
import {PLATFORM_Q_PARAM} from '../../utils/constants.js';
import * as cns from './link_device.module.less';

const link = (code, platform, cb)=>etask(function*(){
    let res;
    try {
        res = yield api.link_device({code, platform});
    } catch(e){
        res = {error: e.message};
    }
    if (res.redirect_url)
        window.location.assign(res.redirect_url);
    if (res.error)
    {
        return cb({
            title: 'Error while linking device:',
            text: res.error,
            icon: 'warn',
            details: <Text.s secondary>
              Uninstall and install EarnApp again.<br/>
              If the issue persists please contact us
            </Text.s>,
        });
    }
    store.use_devices.invalidate();
    store.use_money.invalidate();
    cb({
        text: 'Device successfully linked!',
        icon: 'check',
    });
});

function Status({data={}}){
    const {title, text, icon, details} = data;
    return <Panel className={cns.status}>
      {title&&<Text.m secondary>{title}</Text.m>}
      <div className={cns.row}>
        <Icon ico={icon} size="xxl"/>
        <Text.xl>{text}</Text.xl>
      </div>
      {details&&<Text.s secondary>{details}</Text.s>}
      <Button className={cns.devices_link} view="link"
        color_scheme="accent" left_shift
        href={g_path('/me/passive-income')} ico="passive_income">
        Open devices list
      </Button>
    </Panel>;
}

export function Link_device(){
    const {uuid} = useParams();
    const [res, set_res] = useState({
        text: 'Linking device...',
        icon: 'spinner',
    });
    useEffect(()=>{
        if (!uuid)
            return;
        const params = parse_qs();
        link(uuid, params[PLATFORM_Q_PARAM], set_res);
    }, []);
    return <Page className={cns.root}>
      <Status data={res}/>
    </Page>;
}
